module.exports = __webpack_public_path__ + "static/media/animal.30825404.png";